import styled from "styled-components"

const P = styled.p`
  font-size: 20px;
  color: white;
  line-height: 34px;
`
export default P
